import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CheckboxModule } from 'primeng/checkbox';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'app-feedback-question-group',
  standalone: true,
  templateUrl: './feedback-question-group.component.html',
  styleUrl: '../feedback.component.scss',
  imports: [
    RadioButtonModule,
    CheckboxModule,
    InputTextModule,
    InputTextareaModule,
    FloatLabelModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
  ],
})
export class FeedbackQuestionGroupComponent {
  @Input() category: any;
  @Input() form: FormGroup;
  @Input() QUESTION_PREFIX: string;

  isInvalid(ctrl: string): boolean {
    const c = this.form.get(ctrl);
    return !!(c && c.invalid && (c.dirty || c.touched));
  }
}
